// TODO Silly enums because TS does not support enum extension 🙄
// https://github.com/Microsoft/TypeScript/issues/17592
export var WriteOperation;
(function (WriteOperation) {
    class Operation {
    }
    WriteOperation.Operation = Operation;
    class ContentfulOperation extends Operation {
    }
    WriteOperation.ContentfulOperation = ContentfulOperation;
    class Update extends ContentfulOperation {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "op", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'update'
            });
        }
    }
    WriteOperation.Update = Update;
    class Create extends ContentfulOperation {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "op", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'create'
            });
        }
    }
    WriteOperation.Create = Create;
    class Delete extends Operation {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "op", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'delete'
            });
        }
    }
    WriteOperation.Delete = Delete;
})(WriteOperation || (WriteOperation = {}));
//# sourceMappingURL=types.js.map